import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '@environments/environment';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { Location, LocationTypeName } from '@app/_models/_DTOs/location';
import { LocationService } from '@app/_services/location.service';
import { ITuple } from '@app/_models/tuple';
import { Observable, Subscription } from 'rxjs';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetHistory, AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { AssetService, AuthenticationService } from '@app/_services';
import { DocumentService } from '@app/_services/document.service';
import { NzMessageService } from 'ng-zorro-antd';
import { AssetType } from '@app/_models/enums/assetType';
import { LocationType } from '@app/_models/enums/locationType';
import { AssetDetailsComponent } from '@app/assets/asset-details/asset-details.component';
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { AssetListComponent } from '@app/assets/asset-list/asset-list.component';
import { Employee } from '@app/_models/_DTOs/employee';
import { EmployeeService } from '@app/_services/employee.service';
import { BaseComponent } from '@app/_shared/base.component';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { UserToken } from '@app/_models';
import { ResizeService } from '@app/_services/resize.service';

@Component({
  selector: "app-location-details",
  templateUrl: "./location-details.component.html",
  styleUrls: ["./location-details.component.css"],
})
export class LocationDetailsComponent extends BaseComponent implements OnInit {
  onScreenResize(screenSize: SCREEN_SIZE) {}
  onUserAvailable(userToken: UserToken) {}
  order: string = "-logTime";
  drawerWidth: string = "calc(60vw - 256px)";

  @Input() selectedLocation: Location;
  @Input() level: number;

  selectedEmployee: Employee;

  @Output() drawerClosed = new EventEmitter();

  assetsPageIndex = 1;
  assetsPageSize = 10;
  assetsTotal = 1;
  locationAssetList: Asset[] = [];
  loadingAssets = true;

  @ViewChild(AssetListComponent, { static: false })
  private assetListComponent: AssetListComponent;

  @ViewChild(AssetDetailsComponent, { static: false })
  private assetDetailsComponent: AssetDetailsComponent;

  isAllDisplayDataChecked = false;
  isOperating = false;
  isIndeterminate = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  numberOfChecked = 0;

  apiUrl: string;

  public assetHistoryActionType = AssetHistoryActionType;
  public assetHistoryDocumentStatus = AssetHistoryDocumentStatus;
  public assetTypes = AssetType;

  constructor(
    private locationService: LocationService,
    private assetService: AssetService,
    private employeeService: EmployeeService,
    private documentService: DocumentService,
    private messageService: NzMessageService,
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    super(authenticationService, resizeService);
    this.apiUrl = environment.apiUrl;

    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    });
  }

  ngOnInit() {
    // if (this.selectedLocation) {
    //   this.searchLocationAssets(this.selectedLocation.id, true);
    // }
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    }
  }

  ngOnDestroy() {}

  closeDetails() {
    this.closeAssetDetails();
    this.locationAssetList = [];
    this.selectedLocation = null;
    this.drawerClosed.emit();
  }

  closeAssetDetails() {
    this.assetListComponent.closeAssetDetails();
  }

  getHistory() {
    var history: AssetHistory[] = [];
    if (this.selectedLocation) {
      if (this.selectedLocation.assignedAssets) {
        history.push(...this.selectedLocation.assignedAssets);
      }
      if (this.selectedLocation.unassignedAssets) {
        history.push(...this.selectedLocation.unassignedAssets);
      }
    }
    return history
      .sort((a, b) => {
        var logTimeA = new Date(a.logTime).getTime();
        var logTimeB = new Date(b.logTime).getTime();
        if (logTimeA > logTimeB) return 1;
        if (logTimeA < logTimeB) return -1;
        return 0;
      })
      .filter((x) => x.asset.deleted != 1);
  }

  getPdf(assetHistoryAction: AssetHistory) {
    var document = assetHistoryAction.documents.sort((val1, val2) => {
      return (
        new Date(val2.created).getTime() - new Date(val1.created).getTime()
      );
    })[0];
    this.documentService.getPdf(document.id).subscribe((result: any) => {
      if (result.type == "application/pdf") {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, "_blank");
        }
      } else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    });
  }

  openEmployeeDetails(employee: Employee) {
    this.employeeService.get(employee.id).subscribe((data: Employee) => {
      this.selectedEmployee = data;
    });
  }

  closeEmployeeDetails() {
    this.selectedEmployee = null;
  }

  public getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  public getAssetTypeName(assetType: AssetType) {
    return AssetTypeName.get(assetType);
  }

  public getLocationTypeName(locationType: LocationType) {
    var name = LocationTypeName.get(locationType);
    return name;
  }

  public assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }
}
